import { render, staticRenderFns } from "./Tambah.vue?vue&type=template&id=28336476&scoped=true&"
import script from "./Tambah.vue?vue&type=script&lang=js&"
export * from "./Tambah.vue?vue&type=script&lang=js&"
import style0 from "./Tambah.vue?vue&type=style&index=0&id=28336476&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28336476",
  null
  
)

export default component.exports